import React from 'react';
import { CSSTransition } from 'react-transition-group';
import { Link, withRouter } from 'react-router-dom';
import classNames from 'classnames';
import { connect } from 'react-redux';
import { find } from 'lodash';
import Video from '../parts/video_tile.jsx';
import Footer from '../layout/Footer';
import moment from 'moment-timezone';


class Latest extends React.Component {
  constructor(props){
    super(props);

    this.state = {
      latest: [],
      berlinTemperature: false,
      laTemperature: false
    };
  }
  componentDidMount(){
    document.body.style.background = '';
    document.body.classList.remove('dark');

    this._getWeatherData();
  }

  _getWeatherData(){
    fetch(`https://api.openweathermap.org/data/2.5/weather?q=Berlin,Germany&appid=33722f53e7a1f08aac52ae37a862cb70`)
      .then(response => response.json())
      .then(json => {
        this.setState({
          berlinTemperature: Math.floor(json.main.temp - 273)
        })
      });
    fetch(`https://api.openweathermap.org/data/2.5/weather?q=Los+Angeles&appid=33722f53e7a1f08aac52ae37a862cb70`)
      .then(response => response.json())
      .then(json => {
        this.setState({
          laTemperature: Math.floor(json.main.temp * (9/5) - 459.67)
        })
      });
  }

  render () {
    return <div className='page page--latest transition'>
      <div className="artist__stream">
        {!this.props.loading && this.props.latest.map((item, i) => {
          if(!item.director){
            return null;
          }

          const { preview_video, video } = item;
          const { id, title, ...rest} = video;
          const previewVideo = preview_video ? preview_video : rest;

          return <Video
            {...previewVideo}
            key={id}
            teaser={i == 0}
            to={`/directors/${item.director.slug}/${id}`}
            hover={true}
            title={item.title}
            muted={true}
            suptitle={<span className="name">
              {item.client}
            </span>}
            poster={item.poster}
            subtitle={
              <span className="name" style={{color:item.director.acf.primary_color}} dangerouslySetInnerHTML={{__html: item.director.title.rendered}}>
              </span>
            }
            colors={{
              primary: item.director.acf.primary_color,
              secondary: item.director.acf.secondary_color
            }}
           />
        })}
      </div>
      <div className="page__footer">
        <div className="column column--location">
          <span>Berlin</span>
          <span>{moment().tz("Europe/Berlin").format('hh:mm A')} </span>
          <span>{this.state.berlinTemperature}°C</span>
        </div>
        <div>
          <a href="https://www.instagram.com/akkurat.studios/" target="_blank">
            @akkurat.studios
          </a>
        </div>
        <div className="column column--location">
          <span>Los Angeles</span>
          <span>{moment().tz("America/Los_Angeles").format('hh:mm A')} </span>
          <span>{this.state.laTemperature}°F</span>
        </div>
      </div>
    </div>;
  }
}



const mapStateToProps = (state, ownProps) => {
  let latest = [];

  if(state.directors.loaded){
    state.latest.latest.map(item => {
      const { title } = item;
      const director = find(state.directors.directors, {id: item.artist.ID});

      latest.push({
        ...item,
        director
      });
    })
  }

  return {
    directors: state.directors.directors,
    latest,
    loading: state.latest.loading
  }
}

export default withRouter(connect(mapStateToProps, null)(Latest));
